import {
  SET_MULTIPLE_COUPON_DATA,
  RESET_MULTIPLE_COUPON_DATA
} from 'Store/constants';

const initialState = {
  data: {},
};

const multipleCouponReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_MULTIPLE_COUPON_DATA:
      return { ...state, data: action.payload };

    case RESET_MULTIPLE_COUPON_DATA:
      return { ...state, data: {} };

    default:
      return state;
  }
};

export default multipleCouponReducer;
